module.exports = __webpack_public_path__ + "static/media/Mapa.48338ea7.svg";